export default __webpack_public_path__ + "static/tkmaxx-promo-2024--mobile-ce766e0e6b8f6cd4a0d08ee501d99356.jpg";